import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	globalTransitionLabel: {
		id: 'accessible-workflow-diagram.list-navigation.list-edge.global-transition-label',
		defaultMessage: 'Transition from any status to {parentName}.',
		description: 'Label for global transition',
	},
	loopedTransitionLabel: {
		id: 'accessible-workflow-diagram.list-navigation.list-edge.looped-transition-label',
		defaultMessage: '{transitionName} transition - move issue from {parentName} back to itself.',
		description: 'Label for looped transition',
	},
	globalLoopedTransitionLabel: {
		id: 'accessible-workflow-diagram.list-navigation-list-edge.global-looped-transition-label',
		defaultMessage: '{transitionName} transition - move issue from any status back to itself.',
		description: 'Label for global looped transition',
	},
	initialTransitionLabel: {
		id: 'accessible-workflow-diagram.list-navigation.list-edge.initial-transition-label',
		defaultMessage: '{transitionName} transition - move issue to {targetName}.',
		description: 'Label for initial transition',
	},
	directedTransitionLabel: {
		id: 'accessible-workflow-diagram.list-navigation.list-edge.directed-transition-label',
		defaultMessage: '{transitionName} transition - move issue from {sourceNames} to {targetName}.',
		description: 'Label for directed transition',
	},
	loopedTransitionLabelIssueTermRefresh: {
		id: 'accessible-workflow-diagram.list-navigation.list-edge.looped-transition-label-issue-term-refresh',
		defaultMessage:
			'{transitionName} transition - move work item from {parentName} back to itself.',
		description: 'Label for looped transition',
	},
	globalLoopedTransitionLabelIssueTermRefresh: {
		id: 'accessible-workflow-diagram.list-navigation-list-edge.global-looped-transition-label-issue-term-refresh',
		defaultMessage: '{transitionName} transition - move work item from any status back to itself.',
		description: 'Label for global looped transition',
	},
	initialTransitionLabelIssueTermRefresh: {
		id: 'accessible-workflow-diagram.list-navigation.list-edge.initial-transition-label-issue-term-refresh',
		defaultMessage: '{transitionName} transition - move work item to {targetName}.',
		description: 'Label for initial transition',
	},
	directedTransitionLabelIssueTermRefresh: {
		id: 'accessible-workflow-diagram.list-navigation.list-edge.directed-transition-label-issue-term-refresh',
		defaultMessage:
			'{transitionName} transition - move work item from {sourceNames} to {targetName}.',
		description: 'Label for directed transition',
	},
});
